var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "fixed-right-sidebar" }, [
      _c("div", { staticClass: "sidebar-main" }, [
        _c(
          "div",
          {
            class: [
              "sidebar-item",
              "sidebar-iphone",
              _vm.fixedTab == 2 ? "activeHidden" : ""
            ],
            on: {
              mouseover: function($event) {
                _vm.sidebarTab(2)
              },
              mouseout: _vm.sidebarTabOut
            }
          },
          [
            _c(
              "div",
              {
                class: [
                  "item-bj",
                  _vm.fixedTab == 2 ? ["bj-hover", "bj-hover-call"] : ""
                ]
              },
              [
                _c(
                  "div",
                  {
                    class: [
                      "item-box3",
                      "item-box",
                      _vm.fixedTab == 2 ? "activeH1" : ""
                    ]
                  },
                  [_vm._m(0)]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "sidebar-item",
              "sidebar-wechat",
              _vm.fixedTab == 3 ? "activeHidden" : ""
            ],
            on: {
              mouseover: function($event) {
                _vm.sidebarTab(3)
              },
              mouseout: _vm.sidebarTabOut
            }
          },
          [
            _c("div", {
              class: [
                "item-bj",
                _vm.fixedTab == 3 ? ["bj-hover", "bj-hover-wechat"] : ""
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  "item-box1",
                  "item-box",
                  _vm.fixedTab == 3 ? "activeH1" : ""
                ]
              },
              [
                _c("div", { staticClass: "hover-item" }, [
                  _c("img", {
                    attrs: { src: require("./img/focusCode@2x2.jpg") }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("关注InZ应龙官方微信 实时查看订单最新动态")])
                ])
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.backTopStatus,
              expression: "backTopStatus"
            }
          ],
          staticClass: "sidebar-item sidebar-top"
        },
        [_c("div", { staticClass: "up-img", on: { click: _vm.backTop } })]
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "web-chat-page" } }, [
        _c(
          "div",
          {
            staticClass: "close-btn",
            on: {
              click: function($event) {
                _vm.closeChat()
              }
            }
          },
          [_vm._v("×")]
        ),
        _vm._v(" "),
        _c("iframe", {
          attrs: {
            id: "web-chat-iframe",
            height: "100%",
            width: "100%",
            frameborder: "0",
            src: ""
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hover-item-i" }, [
      _c("div", { staticClass: "item-b" }, [
        _c("div", { staticClass: "call-num" }, [
          _c("p", [
            _c("img", { attrs: { src: require("./img/icon_call.png") } }),
            _vm._v("电话咨询")
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("400-688-2850")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "work-time" }, [
          _c("h3", [_vm._v("工作时间:")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("周一至周五（8:30-18:00）"),
            _c("br"),
            _vm._v("节假日除外")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b53095ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b53095ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/fixed/fixedNew.vue
// module id = null
// module chunks = 